module.exports = __webpack_public_path__ + "static/media/br_border1.36aee397.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/index/img/br_border1.png
// module id = 1504
// module chunks = 0